import React, { useState } from 'react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';

import metadata from './AddLossFormComponent.metadata.json5';
import styles from './AddLossFormComponent.module.scss';

const AddLossFormComponent = (props) => {
    const {
        id,
        model: lossToAdd,
        onSave,
        onCancel,
        onModelChange
    } = props;

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    const [showErrors, setShowErrors] = useState(false);

    const getMaxClaimDate = () => {
        const maxClaimDate = MLLocalDateUtil.date2LocalDate(new Date());
        maxClaimDate.day -= 1;
        return maxClaimDate;
    };

    const overrides = {
        saveLossButton: {
            onClick: () => {
                if (isComponentValid) {
                    onSave(lossToAdd);
                } else {
                    setShowErrors(true);
                }
            }
        },
        cancelAddLoss: {
            onClick: () => {
                onCancel();
            }
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={lossToAdd}
            onValidationChange={setComponentValidation}
            onModelChange={onModelChange}
            showErrors={showErrors}
            classNameMap={styles}
        />
    );
};

AddLossFormComponent.propTypes = {
    id: PropTypes.string.isRequired,
    model: PropTypes.shape({}).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onModelChange: PropTypes.func.isRequired
};

export default AddLossFormComponent;
